<div class="text-center">
	<h4>Are you sure you want to switch to an integrated order?</h4>
	<p class="mt-2">All details you've entered for this order will be lost</p>
</div>
<div class="mt-8 flex items-center justify-center gap-4">
	<app-button btn="secondary" (click)="close()" size="small">No</app-button>
	<app-button (click)="confirm()" size="small">Yes</app-button>
</div>
